import utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IWashcare {
    id: string;
    typeID: number;
    ref: string;
    description: string;
    isHidden: boolean;
    doesNotRequireMaterialBreakdown: boolean;
}

export class Washcare implements IWashcare {

    constructor(data?: IWashcare) {
        if (data) this.update(data);
    }

    update(data: IWashcare): void {
        mapData(data, { root: () => this });
    }

    id: string = utils.emptyGuidValue;
    typeID: number = 0;
    ref: string = "";
    description: string = "";
    isHidden: boolean = false;
    doesNotRequireMaterialBreakdown: boolean = false;
}
